// Marketplace cart — a local (localStorage) cart for buyers. Collects products
// across the catalogue, then submits ONE enquiry to nearby dealers via
// ikart.dealer_marketplace.api.submit_cart_enquiry. This is entirely separate
// from the B2B webshop quotation cart (which ERP customers/sales agents use).

(function () {
	"use strict";

	var CART_KEY = "imek_mkt_cart_v2";
	var mem = null; // in-memory fallback when localStorage is unavailable

	function esc(value) {
		return String(value == null ? "" : value)
			.replace(/&/g, "&amp;").replace(/"/g, "&quot;")
			.replace(/</g, "&lt;").replace(/>/g, "&gt;");
	}
	function t(str) {
		return (window.__ ? window.__(str) : str);
	}

	// ---- storage ----------------------------------------------------------
	function readCart() {
		if (mem) return mem;
		try {
			var raw = window.localStorage.getItem(CART_KEY);
			var items = raw ? JSON.parse(raw) : [];
			return Array.isArray(items) ? items : [];
		} catch (e) {
			mem = [];
			return mem;
		}
	}
	function writeCart(items) {
		items = (items || []).filter(function (it) { return it && it.key; });
		if (mem) { mem = items; syncBadge(); return; }
		try {
			window.localStorage.setItem(CART_KEY, JSON.stringify(items));
		} catch (e) {
			mem = items;
		}
		syncBadge();
	}
	function cartCount() {
		return readCart().reduce(function (n, it) { return n + (Number(it.qty) > 0 ? 1 : 0); }, 0);
	}

	// ---- badge ------------------------------------------------------------
	function syncBadge() {
		var count = cartCount();
		var badges = document.querySelectorAll("[data-imek-mkt-cart-badge]");
		Array.prototype.forEach.call(badges, function (b) {
			b.textContent = count ? String(count) : "";
			b.setAttribute("data-count", String(count));
			b.classList.toggle("hidden", count === 0);
		});

		// Cart entry points only exist while there is something in the cart — an
		// empty cart is a dead end. The marketplace cart lives in localStorage,
		// so only this file can decide; shopping_cart.js defers to us on
		// marketplace pages (see is_marketplace_cart_mode). Both elements ship
		// hidden, so there is no flash of an empty cart before this runs.
		var empty = count === 0;

		// bottom nav cart (server-rendered, hidden by default)
		var items = document.querySelectorAll("[data-imek-cart-item]");
		Array.prototype.forEach.call(items, function (li) {
			li.classList.toggle("hidden", empty);
		});

	}

	// ---- add / update -----------------------------------------------------
	function itemKey(payload) {
		// A product chosen for a specific dealer is a distinct cart line from
		// the same product added to the nearby-dealer pool (or to a different
		// dealer), so the dealer id is part of the key.
		var dealerPart = payload.dealer ? "@" + payload.dealer : "";
		return (payload.dealer_own_product
			? "own:" + payload.dealer_own_product
			: "wi:" + (payload.website_item || payload.item_code || payload.title)) + dealerPart;
	}
	function addToCart(payload) {
		if (!payload || (!payload.website_item && !payload.dealer_own_product)) return;
		var items = readCart();
		var key = itemKey(payload);
		var existing = items.find(function (it) { return it.key === key; });
		var qty = Number(payload.qty) > 0 ? Number(payload.qty) : 1;
		if (existing) {
			existing.qty = (Number(existing.qty) || 1) + qty;
		} else {
			items.push({
				key: key,
				website_item: payload.website_item || null,
				dealer_own_product: payload.dealer_own_product || null,
				item_code: payload.item_code || null,
				title: payload.title || payload.product_name || payload.item_code || "",
				route: payload.route || "",
				image: payload.image || "",
				uom: payload.uom || "",
				dealer: payload.dealer || null,
				dealer_name: payload.dealer_name || null,
				qty: qty
			});
		}
		writeCart(items);
		showToast(payload.dealer_name ? t("Added to cart for {0}").replace("{0}", payload.dealer_name) : t("Added to cart"));
		renderCartPage();
	}
	function setQty(key, qty) {
		var items = readCart();
		var it = items.find(function (row) { return row.key === key; });
		if (!it) return;
		it.qty = Number(qty) > 0 ? Number(qty) : 1;
		writeCart(items);
		renderCartPage();
	}
	function removeItem(key) {
		writeCart(readCart().filter(function (it) { return it.key !== key; }));
		renderCartPage();
	}

	// ---- toast ------------------------------------------------------------
	function showToast(message) {
		var el = document.querySelector("[data-imek-mkt-toast]");
		if (!el) {
			el = document.createElement("div");
			el.className = "imek-mkt-toast";
			el.setAttribute("data-imek-mkt-toast", "");
			document.body.appendChild(el);
		}
		el.innerHTML = '<span class="imek-mkt-toast-icon" aria-hidden="true"></span><span>' + esc(message) + '</span>'
			+ ' <a class="imek-mkt-toast-link" href="/cart">' + esc(t("View cart")) + '</a>';
		el.classList.add("imek-mkt-toast-show");
		clearTimeout(el._hideTimer);
		el._hideTimer = setTimeout(function () { el.classList.remove("imek-mkt-toast-show"); }, 3200);
	}

	// ---- cart page --------------------------------------------------------
	function money(value) {
		try { return window.frappe && frappe.format ? frappe.format(value, { fieldtype: "Currency" }, { only_value: true }) : "₹" + value; }
		catch (e) { return "₹" + value; }
	}
	function itemRowHtml(it) {
		var image = it.image
			? '<img src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy" data-mkt-cart-image>'
			: '<span class="imek-mkt-cart-thumb-fallback" aria-hidden="true">' + esc((it.title || "?").charAt(0).toUpperCase()) + "</span>";
		var thumbnailHtml = it.route
			? '<a class="imek-mkt-cart-thumb" href="/' + esc(it.route) + '">' + image + "</a>"
			: '<span class="imek-mkt-cart-thumb" aria-hidden="true">' + image + "</span>";
		var titleHtml = it.route
			? '<a class="imek-mkt-cart-title" href="/' + esc(it.route) + '">' + esc(it.title) + "</a>"
			: '<span class="imek-mkt-cart-title">' + esc(it.title) + "</span>";
		return (
			'<div class="imek-mkt-cart-row" data-mkt-cart-row="' + esc(it.key) + '">' +
				thumbnailHtml +
				'<div class="imek-mkt-cart-info">' +
					titleHtml +
					(it.dealer_name ? '<div class="imek-mkt-cart-dealer">' + esc(t("Dealer") + ": " + it.dealer_name) + "</div>" : "") +
					(it.uom ? '<div class="imek-mkt-cart-uom">' + esc(it.uom) + "</div>" : "") +
				"</div>" +
				'<div class="imek-mkt-cart-controls">' +
					'<div class="imek-qty-stepper" data-mkt-cart-qty>' +
						'<button type="button" class="imek-qty-btn" data-mkt-cart-minus aria-label="' + esc(t("Decrease")) + '">&minus;</button>' +
						'<input class="imek-qty-value" type="number" min="1" step="any" value="' + esc(it.qty || 1) + '" data-mkt-cart-qty-input aria-label="' + esc(t("Quantity")) + '">' +
						'<button type="button" class="imek-qty-btn" data-mkt-cart-plus aria-label="' + esc(t("Increase")) + '">+</button>' +
					"</div>" +
					'<button type="button" class="imek-mkt-cart-remove" data-mkt-cart-remove aria-label="' + esc(t("Remove")) + '">&times;</button>' +
				"</div>" +
			"</div>"
		);
	}
	function renderCartPage() {
		var section = document.querySelector('[data-imek-cart-mode="marketplace"].imek-mkt-cart');
		if (!section) return;
		var items = readCart();
		var $empty = section.querySelector("[data-mkt-cart-empty]");
		var $layout = section.querySelector("[data-mkt-cart-layout]");
		var $success = section.querySelector("[data-mkt-cart-success]");
		if ($success && !$success.hidden) return; // keep success state until reload
		var $items = section.querySelector("[data-mkt-cart-items]");
		if (!items.length) {
			if ($empty) $empty.hidden = false;
			if ($layout) $layout.hidden = true;
			return;
		}
		if ($empty) $empty.hidden = true;
		if ($layout) $layout.hidden = false;
		if ($items) $items.innerHTML = items.map(itemRowHtml).join("");
	}

	// ---- city options for the checkout form -------------------------------
	function loadCityOptions(select) {
		if (!select || !window.frappe || !frappe.call) return;
		frappe.call({ method: "ikart.dealer_marketplace.api.get_dealer_locations" })
			.then(function (r) {
				var locations = (r && r.message) || [];
				locations.forEach(function (loc) {
					var value = loc.district || loc.city || loc;
					if (!value) return;
					var opt = document.createElement("option");
					opt.value = value;
					opt.textContent = value;
					select.appendChild(opt);
				});
			});
	}

	// ---- checkout ---------------------------------------------------------
	function handleCheckout(form) {
		var section = form.closest(".imek-mkt-cart");
		var errorEl = section.querySelector("[data-mkt-cart-error]");
		errorEl.textContent = "";
		var name = (form.customer_name.value || "").trim();
		var mobile = (form.mobile_no.value || "").replace(/\D/g, "");
		if (!name) { errorEl.textContent = t("Please enter your name."); return; }
		if (mobile.length !== 10) { errorEl.textContent = t("Enter a valid 10 digit mobile number."); return; }
		var city = form.city.value || "";
		if (!city) { errorEl.textContent = t("Select your city so we can find dealers near you."); return; }
		var cartItems = readCart();
		var items = cartItems.map(function (it) {
			return { website_item: it.website_item, dealer_own_product: it.dealer_own_product, qty: it.qty, uom: it.uom, dealer: it.dealer || null };
		});
		if (!items.length) { errorEl.textContent = t("Your cart is empty."); return; }
		// distinct dealers explicitly chosen via the Find Dealers popup — if any,
		// the enquiry targets exactly those; otherwise it fans out to nearby.
		var chosenDealers = [];
		cartItems.forEach(function (it) {
			if (it.dealer && chosenDealers.indexOf(it.dealer) === -1) chosenDealers.push(it.dealer);
		});

		var $btn = form.querySelector("[type=submit]");
		$btn.disabled = true;
		frappe.call({
			method: "ikart.dealer_marketplace.api.submit_cart_enquiry",
			args: {
				items: JSON.stringify(items),
				customer_name: name,
				mobile_no: mobile,
				city: city,
				delivery_method: form.delivery_method.value,
				message: form.message.value,
				dealers: chosenDealers.length ? JSON.stringify(chosenDealers) : null
			},
			callback: function (r) {
				$btn.disabled = false;
				var data = r && r.message;
				if (!data || !data.enquiry) return;
				writeCart([]); // clear the cart on success
				var url = window.location.origin + data.url;
				var $success = section.querySelector("[data-mkt-cart-success]");
				var $layout = section.querySelector("[data-mkt-cart-layout]");
				var $empty = section.querySelector("[data-mkt-cart-empty]");
				if ($layout) $layout.hidden = true;
				if ($empty) $empty.hidden = true;
				if ($success) {
					$success.querySelector("[data-mkt-cart-success-message]").textContent = data.message;
					$success.querySelector("[data-mkt-cart-success-url]").value = url;
					$success.querySelector("[data-mkt-cart-success-link]").setAttribute("href", data.url);
					$success.hidden = false;
				}
			}
		}).fail(function (xhr) {
			$btn.disabled = false;
			var data = xhr && xhr.responseJSON;
			if (!data || !data._server_messages) {
				errorEl.textContent = t("Could not send the enquiry. Please try again.");
			}
		});
	}

	// ---- Webshop Product Group: in-place variant swap ----------------------
	// Same behaviour as the B2B webshop grid's .product-size-option buttons
	// (ikart.webshop.product_ui.update_group_variant_purchase_state /
	// update_product_price in product_ui/grid.js): clicking a variant updates
	// the card's photo, title, price and Add to Cart target WITHOUT
	// navigating the page.
	function selectGroupVariant(button, popup) {
		var card = button.closest(".imek-shop-card");
		if (!card) return;
		var purchaseScope = popup || card;

		var group = button.closest(".imek-shop-card-group");
		if (group) {
			var buttons = group.querySelectorAll(".imek-shop-card-group-option");
			Array.prototype.forEach.call(buttons, function (b) {
				b.classList.toggle("active", b === button);
				b.setAttribute("aria-pressed", b === button ? "true" : "false");
			});
		}

		var route = button.getAttribute("data-route") || "";
		var image = button.getAttribute("data-image") || "";
		var title = button.getAttribute("data-title") || "";
		var formattedPrice = button.getAttribute("data-formatted-price") || "";
		if (/^(none|null|undefined)$/i.test(formattedPrice.trim())) formattedPrice = "";
		var stockUom = button.getAttribute("data-stock-uom") || "";
		var websiteItem = button.getAttribute("data-website-item") || "";
		var itemCode = button.getAttribute("data-item-code") || "";
		var webshopLink = card.querySelector(".imek-shop-webshop-btn");
		if (webshopLink && route) webshopLink.setAttribute("href", "/" + route);
		var popupLink = purchaseScope.querySelector("[data-mkt-webshop-order]");
		if (popupLink && route) popupLink.setAttribute("href", "/" + route);

		// image: rebuild the media box's inner content so switching between a
		// variant that has a photo and one that doesn't (image <-> fallback
		// letter avatar) always ends up correctly structured — matching how
		// the B2B webshop grid's update_product_image swaps structure, not
		// just attributes, for the same reason (product_ui/grid.js).
		var mediaBox = card.querySelector(".imek-shop-card-media");
		if (mediaBox) {
			var badge = mediaBox.querySelector(".imek-shop-badge");
			var badgeHtml = badge ? badge.outerHTML : "";
			var initial = esc((title || "?").charAt(0).toUpperCase());
			mediaBox.innerHTML =
				badgeHtml +
				(image
					? '<button type="button" class="imek-shop-card-image-trigger" data-mkt-image-preview' +
						' data-image-src="' + esc(image) + '" data-image-alt="' + esc(title) + '"' +
						' aria-label="' + esc(t("View larger image of {0}").replace("{0}", title)) + '">' +
						'<img src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy" decoding="async">' +
						"</button>"
					: '<a href="/' + esc(route) + '" class="imek-shop-card-fallback-link">' +
						'<span class="imek-shop-card-fallback" aria-hidden="true">' + initial + "</span>" +
						"</a>");
		}

		// title + link
		var titleEl = card.querySelector(".imek-shop-card-title");
		if (titleEl) {
			if (title) titleEl.textContent = title;
			if (route) titleEl.setAttribute("href", "/" + route);
		}

		// price (variant payload only carries the plain formatted price — no
		// MRP/discount, same limitation the webshop grid's swap has). ERP
		// customers see it inline on the card face (.imek-shop-card-price);
		// everyone else sees it inside the buy popup (.imek-atc-pricebox) —
		// only one of the two exists per card, but there is no harm checking both.
		var priceEl = card.querySelector(".imek-shop-card-price");
		var atcPriceEl = purchaseScope.querySelector(".imek-atc-pricebox");
		if (priceEl) {
			priceEl.innerHTML = formattedPrice
				? '<span class="imek-shop-price">' + esc(formattedPrice) + "</span>" +
					(stockUom ? '<span class="imek-shop-uom">/ ' + esc(stockUom) + "</span>" : "")
				: '<span class="imek-shop-price-tbc">' + esc(t("Price on request")) + "</span>";
		}
		if (atcPriceEl) {
			atcPriceEl.innerHTML = formattedPrice
				? '<span class="imek-atc-price">' + esc(formattedPrice) + "</span>" +
					(stockUom ? '<span class="imek-atc-priceuom">/ ' + esc(stockUom) + "</span>" : "")
				: '<span class="imek-shop-price-tbc">' + esc(t("Price on request")) + "</span>";
		}

		// buy popup: title, image and qty-uom follow the same variant swap.
		// Rebuilding the media box's content (not just an attribute) matches
		// how the card's own .imek-shop-card-media is handled just above, for
		// the same reason: switching between a variant that has a photo and
		// one that doesn't has to add/remove the <img> itself, not just its src.
		var atcTitle = purchaseScope.querySelector(".imek-atc-title");
		if (atcTitle && title) atcTitle.textContent = title;

		var atcMedia = purchaseScope.querySelector(".imek-atc-media");
		if (atcMedia) {
			atcMedia.innerHTML = image
				? '<img class="imek-atc-image" src="' + esc(image) + '" alt="' + esc(title) + '">'
				: "";
		}

		var atcUom = purchaseScope.querySelector(".imek-atc-uom");
		if (atcUom) atcUom.textContent = stockUom;

		// Add to Cart target — the button carries the cart payload as JSON
		var addBtn = purchaseScope.querySelector("[data-mkt-add-to-cart]");
		if (addBtn && websiteItem) {
			addBtn.setAttribute(
				"data-mkt-item",
				JSON.stringify({
					website_item: websiteItem,
					item_code: itemCode,
					title: title,
					route: route,
					image: image,
					uom: stockUom
				})
			);
		}

		// Dealer availability is variant-specific too. Keep Find Dealers in
		// lockstep with the cart target so it never opens for the old
		// representative variant after a buyer makes a selection.
		var findDealerBtn = card.querySelector("[data-mkt-find-dealer]");
		if (findDealerBtn && websiteItem) {
			findDealerBtn.setAttribute("data-website-item", websiteItem);
			findDealerBtn.setAttribute("data-product-name", title);
			findDealerBtn.setAttribute("data-product-route", route);
			findDealerBtn.setAttribute("data-product-image", image);
			findDealerBtn.setAttribute("data-product-uom", stockUom);
		}
	}

	// ---- buy popup: price + qty, opened from the card's circular trigger --
	// Same design as the B2B webshop grid's add-to-cart popup (product_ui/
	// grid.js open_add_to_cart_popup/close_add_to_cart_popup) and reusing its
	// exact .imek-atc-* classes, but this is its own small implementation:
	// the webshop popup is built dynamically in JS and appended to document.body,
	// wired to update_cart/bind_add_to_cart_action, none of which apply here.
	//
	// This popup is server/JS-rendered as part of the card itself instead, so it
	// starts out NESTED inside .imek-shop-card — which is exactly the problem:
	// .imek-wsh-panel .imek-shop-card:hover sets `transform: translateY(-3px)`
	// (a hover-lift; the plain B2B grid's own .card does the same). A transform
	// on an ancestor makes it the containing block for any position:fixed
	// descendant, so while the pointer sits over the card — which is exactly
	// when a real click on the trigger happens, transform included — this
	// overlay would render fixed to the CARD's own (overflow:hidden) box
	// instead of the viewport, trapped in place rather than covering the
	// screen (measured: shrunk to the card's footprint, not centered).
	// Reparenting to document.body while open sidesteps it entirely, matching
	// how the webshop's own popup avoids the same class of bug. Moving it back
	// on close preserves the card's state. While open, option selections pass
	// the detached popup to selectGroupVariant so purchase details update too.
	function openBuyPopup(trigger) {
		var card = trigger.closest(".imek-shop-card");
		var popup = card && card.querySelector("[data-mkt-buy-popup]");
		// ERP customers choose the saved group option here, then continue to
		// its webshop item page. Never send them to the marketplace enquiry cart.
		if (!popup && card && trigger.matches(".imek-shop-webshop-btn")) {
			popup = document.createElement("div");
			popup.className = "imek-atc-overlay";
			popup.setAttribute("data-mkt-buy-popup", "");
			popup.hidden = true;
			var title = card.querySelector(".imek-shop-card-title").textContent.trim();
			var img = card.querySelector(".imek-shop-card-media img");
			var price = card.querySelector(".imek-shop-card-price");
			popup.innerHTML = '<div class="imek-atc-card" role="dialog" aria-modal="true" aria-label="' + esc(t("Available options")) + '">' +
				'<button type="button" class="imek-atc-close" data-mkt-buy-dismiss aria-label="' + esc(t("Close")) + '">&times;</button>' +
				'<div class="imek-atc-media">' + (img ? '<img class="imek-atc-image" src="' + esc(img.getAttribute("src")) + '" alt="' + esc(title) + '">' : '') + '</div>' +
				'<h3 class="imek-atc-title">' + esc(title) + '</h3>' +
				'<div class="imek-atc-pricebox">' + (price ? price.innerHTML : '') + '</div>' +
				'<a class="btn btn-sm btn-primary imek-atc-confirm" data-mkt-webshop-order href="' + esc(trigger.getAttribute("href")) + '">' + esc(t("Order via Webshop")) + '</a></div>';
			card.appendChild(popup);
		}
		if (!popup) return;
		popup._imekTrigger = trigger;
		var oldOptions = popup.querySelector(".imek-atc-options");
		if (oldOptions) oldOptions.remove();
		var cardOptions = card.querySelectorAll(".imek-shop-card-group-option");
		if (cardOptions.length) {
			var options = document.createElement("div");
			options.className = "imek-atc-options";
			options.setAttribute("role", "group");
			options.setAttribute("aria-label", t("Available options"));
			Array.prototype.forEach.call(cardOptions, function (source) {
				var option = document.createElement("button");
				option.type = "button";
				option.className = "imek-atc-option";
				option.classList.toggle("active", source.classList.contains("active"));
				option.setAttribute("aria-pressed", source.getAttribute("aria-pressed"));
				option.setAttribute("data-item-code", source.getAttribute("data-item-code"));
				option.textContent = source.textContent.trim();
				option.addEventListener("click", function () {
					selectGroupVariant(source, popup);
					Array.prototype.forEach.call(options.children, function (button) {
						button.classList.toggle("active", button === option);
						button.setAttribute("aria-pressed", button === option ? "true" : "false");
					});
				});
				options.appendChild(option);
			});
			var priceBox = popup.querySelector(".imek-atc-pricebox");
			priceBox.parentNode.insertBefore(options, priceBox);
		}
		popup._imekHome = { parent: popup.parentNode, next: popup.nextSibling };
		document.body.appendChild(popup);
		popup.hidden = false;
		document.body.classList.add("imek-atc-open");
		var qty = popup.querySelector("[data-mkt-qty-input]");
		if (qty) {
			// Back to blank on every open. Unlike the webshop popup, which is
			// rebuilt from scratch each time (product_ui/grid.js), this one is
			// rendered with the card and reused — so without this it reopens
			// holding whatever the last visit typed or stepped to, and the
			// field stops meaning "unset" the moment it is touched once.
			qty.value = "";
			qty.focus();
		}
		else {
			var firstOption = popup.querySelector(".imek-atc-option.active, .imek-atc-option");
			if (firstOption) firstOption.focus();
		}
	}

	function closeBuyPopup(popup) {
		if (!popup) return;
		popup.hidden = true;
		document.body.classList.remove("imek-atc-open");
		var home = popup._imekHome;
		if (home && home.parent) {
			home.parent.insertBefore(popup, home.next);
			popup._imekHome = null;
		}
		if (popup._imekTrigger) popup._imekTrigger.focus({ preventScroll: true });
	}

	// ---- events -----------------------------------------------------------
	function bind() {
		// A file may be removed after an item was placed in localStorage. Turn a
		// failed thumbnail into the same harmless initial fallback used for items
		// that never had an image, instead of exposing a broken-image icon.
		document.addEventListener("error", function (event) {
			var image = event.target;
			if (!image || !image.matches || !image.matches("[data-mkt-cart-image]")) return;
			var fallback = document.createElement("span");
			fallback.className = "imek-mkt-cart-thumb-fallback";
			fallback.setAttribute("aria-hidden", "true");
			fallback.textContent = ((image.alt || "?").trim() || "?").charAt(0).toUpperCase();
			image.replaceWith(fallback);
		}, true);

		document.addEventListener("click", function (e) {
			var variantBtn = e.target.closest(".imek-shop-card-group-option");
			if (variantBtn) {
				e.preventDefault();
				selectGroupVariant(variantBtn);
				return;
			}

			var buyTrigger = e.target.closest("[data-mkt-buy-trigger]");
			if (buyTrigger) {
				e.preventDefault();
				openBuyPopup(buyTrigger);
				return;
			}
			var buyDismiss = e.target.closest("[data-mkt-buy-dismiss]");
			if (buyDismiss) {
				e.preventDefault();
				closeBuyPopup(buyDismiss.closest("[data-mkt-buy-popup]"));
				return;
			}
			// backdrop click: the overlay IS the click target, not one of its
			// descendants (the popup card itself stops the click before it gets here)
			if (e.target.matches && e.target.matches("[data-mkt-buy-popup]")) {
				closeBuyPopup(e.target);
				return;
			}
			var buyStep = e.target.closest(".imek-atc-step");
			if (buyStep) {
				e.preventDefault();
				var qtyRow = buyStep.closest(".imek-atc-qtyrow");
				var qtyInput = qtyRow && qtyRow.querySelector("[data-mkt-qty-input]");
				if (qtyInput) {
					var next = (Number(qtyInput.value) || 1) + (Number(buyStep.getAttribute("data-step")) || 0);
					qtyInput.value = Math.max(1, next);
				}
				return;
			}

			// Product-card qty is type-only everywhere except the buy popup above
			// (dealer_page.html, item_add_to_cart.html) — no step handler needed
			// there. The CART page keeps its own steppers (cart_items.html /
			// cart.js), which are separate too.
			var addBtn = e.target.closest("[data-mkt-add-to-cart]");
			if (addBtn) {
				e.preventDefault();
				var payload;
				try { payload = JSON.parse(addBtn.getAttribute("data-mkt-item") || "{}"); }
				catch (err) { payload = {}; }
				var scope = addBtn.closest("[data-mkt-add-scope]");
				if (scope) {
					var qi = scope.querySelector("[data-mkt-qty-input]");
					if (qi) payload.qty = Number(qi.value) || 1;
				}
				addToCart(payload);
				// close the buy popup this button lives in, if any — the dealer
				// Find-Dealers modal's own add-to-cart button is not inside one.
				closeBuyPopup(addBtn.closest("[data-mkt-buy-popup]"));
				return;
			}
			var row = e.target.closest("[data-mkt-cart-row]");
			if (!row) return;
			var key = row.getAttribute("data-mkt-cart-row");
			if (e.target.closest("[data-mkt-cart-remove]")) { removeItem(key); return; }
			if (e.target.closest("[data-mkt-cart-plus]")) {
				var inc = row.querySelector("[data-mkt-cart-qty-input]");
				setQty(key, (Number(inc.value) || 1) + 1); return;
			}
			if (e.target.closest("[data-mkt-cart-minus]")) {
				var dec = row.querySelector("[data-mkt-cart-qty-input]");
				setQty(key, Math.max(1, (Number(dec.value) || 1) - 1)); return;
			}
		});
		document.addEventListener("keydown", function (e) {
			if (e.key !== "Escape") return;
			var openPopup = document.querySelector("[data-mkt-buy-popup]:not([hidden])");
			if (openPopup) closeBuyPopup(openPopup);
		});
		document.addEventListener("change", function (e) {
			var input = e.target.closest("[data-mkt-cart-qty-input]");
			if (!input) return;
			var row = input.closest("[data-mkt-cart-row]");
			if (row) setQty(row.getAttribute("data-mkt-cart-row"), input.value);
		});
		document.addEventListener("submit", function (e) {
			var form = e.target.closest("[data-mkt-cart-form]");
			if (!form) return;
			e.preventDefault();
			handleCheckout(form);
		});
		var copyBtn = document.querySelector("[data-mkt-cart-copy]");
		if (copyBtn) copyBtn.addEventListener("click", function () {
			var url = document.querySelector("[data-mkt-cart-success-url]");
			if (url && navigator.clipboard) navigator.clipboard.writeText(url.value);
		});
	}

	// shopping_cart.js injects the floating cart pill on frappe.ready too, and
	// the order between these two files is not guaranteed. If it wins the race
	// the pill appears AFTER our syncBadge() and would stay hidden despite a
	// full cart — so it calls this back once the pill exists.
	window.imekMktCart = window.imekMktCart || {};
	window.imekMktCart.syncBadge = syncBadge;

	function init() {
		bind();
		syncBadge();
		renderCartPage();
		var citySelect = document.querySelector('[data-mkt-cart-form] [name="city"]');
		if (citySelect) loadCityOptions(citySelect);
	}

	if (window.frappe && frappe.ready) frappe.ready(init);
	else if (document.readyState !== "loading") init();
	else document.addEventListener("DOMContentLoaded", init);
})();
